import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonDirective } from './button/button.directive';
import { ButtonPrimaryDirective } from './button-primary/button-primary.directive';
import { TextInputDirective } from './text-input/text-input.directive';
import { HeadlineDirective } from './headline/headline.directive';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ButtonDirective,
    ButtonPrimaryDirective,
    TextInputDirective,
    HeadlineDirective,
    FooterComponent
  ],
  exports: [
    ButtonDirective,
    ButtonPrimaryDirective,
    TextInputDirective,
    FooterComponent
  ]
})
export class UiModule { }



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/ui/ui.module.ts